// extracted by css-extract-rspack-plugin
export default {"imageAttachment":"imageAttachment-LZAq6a","fileAttachment":"fileAttachment-FXKkCe","fileLabel":"fileLabel-o2DYX1"};